import {
  CLEAR_BARCODE_SEARCH,
  FETCH_BARCODE_SEARCH,
  FETCH_BARCODE_SEARCH_FULFILLED,
  FETCH_BARCODE_SEARCH_REJECTED,
} from 'b2b-apps/shop/catalog/redux/barcodeSearch/actionTypes';
import {
  BarcodeSearchType,
  ClearBarcodeSearchAction,
  FetchBarcodeSearchAction,
  FetchBarcodeSearchFulfilledAction,
  FetchBarcodeSearchRejectedAction,
} from 'b2b-common/core/catalog/api/BarcodeSearchTypes';

const clearBarcodeSearch = (): ClearBarcodeSearchAction => ({
  type: CLEAR_BARCODE_SEARCH,
});

const fetchBarcodeSearch = (barcode: string): FetchBarcodeSearchAction => ({
  type: FETCH_BARCODE_SEARCH,
  payload: {
    barcode,
  },
});

const fetchBarcodeSearchFulfilled = (
  barcode: string,
  data: BarcodeSearchType,
): FetchBarcodeSearchFulfilledAction => ({
  type: FETCH_BARCODE_SEARCH_FULFILLED,
  payload: {
    barcode,
    data,
  },
});

const fetchBarcodeSearchRejected = (
  barcode: string,
  error: ErrorType,
): FetchBarcodeSearchRejectedAction => ({
  type: FETCH_BARCODE_SEARCH_REJECTED,
  payload: {
    barcode,
    error,
  },
});

export {
  clearBarcodeSearch,
  fetchBarcodeSearch,
  fetchBarcodeSearchFulfilled,
  fetchBarcodeSearchRejected,
};
